export default __webpack_public_path__ + "static/media/forestly-expl-07_EN.993e5dc1.png";